import { mergeAttributes, Node } from '@tiptap/core';


/** add CreatorLogo component integration into tiptap */
export const CreatorLogo_server = Node.create({
    name: 'CreatorLogo',
    group: 'inline',
    inline: true,
    atom: true,
    draggable: true,
    selectable: true,
    addAttributes() {
        return {
            ytid: { "default": null },
            auto: { "default": false },
        };
    },
    parseHTML() {
        return [{ tag: 'CreatorLogo' }];
    },

    renderHTML({ HTMLAttributes }) {
        return ['span', mergeAttributes(HTMLAttributes,
            { "class": `text-4xl w-1em my-4 mx-auto aspect-square rounded-full animate-spin border-y-2 border-solid border-current border-t-transparent shadow-lg text-nfPurple-400` }),
        ];
    },


})
